'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var API_END_POINT = exports.API_END_POINT = 'api/v1';
var API_END_POINT_V2 = exports.API_END_POINT_V2 = 'api/v2';

/**
 * response data parameters
 */
var RESPONSE_PARAMS = exports.RESPONSE_PARAMS = {
  DATA: 'data',
  DATA_TYPE: 'dataType',
  CODE: 'code',
  MESSAGE: 'message'
};

/**
 * response codes
 */
var RESPONSE_CODES = exports.RESPONSE_CODES = {
  OK: 200,
  NON_AUTHORITATIVE: 203,
  DATA_RECEIVED: 250,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  NOT_AUTHORIZED: 401,
  INTERNAL_SERVER_ERROR: 500
};

/**
 * server SERVLETS
 */
var SERVLETS = exports.SERVLETS = {
  CUSTOM_METHOD_SERVLET: '/servlet/CustomMethodServlet'
};

/**
 * Http method types
 */
var METHOD_TYPES = exports.METHOD_TYPES = {
  POST: 'post',
  GET: 'get',
  PUT: 'put',
  DELETE: 'delete'
};